import { useEffect } from 'react';

const CookiesBlock = ({ cookieBotId, culture }) => {
  useEffect(() => {
    const cookieBotWrapper = document.getElementById('CookiebotDeclaration');
    if (cookieBotWrapper && cookieBotId) {
      const script = document.createElement('script');
      script.id = 'CookieDeclaration';
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://consent.cookiebot.com/${cookieBotId}/cd.js`;

      if (culture) {
        script.setAttribute('data-culture', culture);
      }

      cookieBotWrapper.appendChild(script);
    }
  }, [cookieBotId, culture]);

  return <div id="CookiebotDeclaration" />;
};
export default CookiesBlock;
